import { getDefaultProvider } from 'ethers'

export const useEnsProvider = () => {
  const network = process.env.REACT_APP_ENS_PROVIDER
  const provider = getDefaultProvider(network)
  return provider
}
